import isProduction from "./isProduction";
const devFreeze = obj => isProduction() ? obj : Object.freeze(obj);
export default devFreeze;